
import React from 'react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/components/theme/ThemeProvider';

interface DeviceStatusProps {
  status: 'online' | 'offline' | 'warning';
  animate?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const DeviceStatus: React.FC<DeviceStatusProps> = ({ 
  status, 
  animate = true,
  size = 'md'
}) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  
  const sizeClasses = {
    sm: 'h-2 w-2',
    md: 'h-3.5 w-3.5',
    lg: 'h-4 w-4'
  };
  
  return (
    <span
      className={cn(
        "rounded-full inline-block",
        sizeClasses[size],
        status === 'online' && (isDark ? "bg-[#00D25B]" : "bg-green-500"),
        status === 'offline' && "bg-gray-400",
        status === 'warning' && "bg-amber-500",
        animate && status === 'online' && "animate-pulse-slow"
      )}
    />
  );
};

export default DeviceStatus;
